import Button from 'components/Button'
import ErrorMessageModal from 'components/Modals/ErrorMessageModal'
import LoaderModal from 'components/Modals/LoaderModal'
import Stepper from 'components/Stepper'
import { useRiseUpAPIV1 } from 'hooks/useRiseUpAPIV1'
import queryString from 'query-string'
import React, { useState } from 'react'
import ReactGA from 'react-ga4'
import { useLocation, useNavigate } from 'react-router-dom'
import { getModifiedUrlWithStep } from 'utils'
import { consoleLog } from 'utils/simpleLogger'
import CompanyLogo from '../../../assets/afbc.png'
import Side1 from '../../../assets/new_side_13.jpg'
import { IFormProps, InvestingPersonEnum } from '../../../interfaces'

const BankWire = (props: IFormProps) => {
  const [error, setError] = useState('')
  const [isLoading, setIsLoading] = useState(false)
  const navigate = useNavigate()
  const location = useLocation()

  const { finalizeUserCreation, sendWirePaymentReminderEmail } = useRiseUpAPIV1()

  const handleConfirmWirePayment = async () => {
    try {
      setIsLoading(true)
      const sendWireRes = await sendWirePaymentReminderEmail(
        props.getValues('onboardingId'),
        props.getValues('investingProfile.tradeId'),
      )
      consoleLog(sendWireRes)
      const res = await finalizeUserCreation(props.getValues('onboardingId'))
      const pathname = location.pathname
      const currentParams = queryString.parse(location.search)
      const updatedUrl = getModifiedUrlWithStep(pathname, currentParams, 'success_page')
      navigate(updatedUrl)
      props.nextStep('Success')
      consoleLog(res)
    } catch (error) {
      ReactGA.event({
        category: 'Wire Payment page',
        action: `Wire Payment page error`,
        label: JSON.stringify(error),
      })
      consoleLog(error)
      setIsLoading(false)
    }
  }

  return (
    <div className="flex h-screen w-full flex-col md:flex-row md:justify-start">
      <div className="mt-10 flex flex-col sm:w-screen md:mt-0 md:min-h-screen md:w-[45%] lg:w-[40%] xl:w-[35%]">
        <div className="relative sm:h-auto sm:p-16 md:hidden">
          <img className="w-screen" src={CompanyLogo} alt="CompanyLogo" />
        </div>
        <div className="relative hidden flex-grow md:flex">
          <img className="flex h-screen w-full" src={Side1} alt="Side1" />
        </div>
      </div>

      <div className="flex flex-col p-10 sm:w-[100%] md:w-[55%] lg:h-screen lg:w-[60%] lg:overflow-y-scroll xl:w-[65%]">
        {/* <div className="justify-center my-10 hidden lg:flex">
          <div className="w-1/2">
            <img className="w-screen" src={CompanyLogo} alt="CompanyLogo" />
          </div>
        </div> */}

        <div className="md:my-3">
          <Stepper current={props.currentStage} />
        </div>

        <div className="z-10 pb-8 pt-10 text-left text-2xl font-semibold text-gray-900 md:text-4xl lg:pb-10">
          Wire Payment Details
        </div>

        <div className="px-0">
          <div className="pb-2 text-left text-xl font-medium text-gray-900 md:text-2xl lg:text-left">
            North Capital Private Securities
          </div>
          <div className="mt-4 flex flex-col text-base md:mt-0">
            <div className="mb-2 flex flex-col justify-between md:mb-0 md:flex-row md:justify-start">
              <div className="text-gray-600"> Receiving Bank: </div>
              <div className="font-bold md:ml-3">TriState Capital Bank</div>
            </div>

            <div className="mb-2 flex flex-col justify-between md:mb-0 md:flex-row md:justify-start">
              <div className="text-gray-600">Account Number: </div>
              <div className="font-bold md:ml-3">0220003339</div>
            </div>

            <div className="mb-2 flex flex-col justify-between md:mb-0 md:flex-row md:justify-start">
              <div className="text-gray-600">Routing Number: </div>
              <div className="font-bold md:ml-3">043019003</div>
            </div>

            <div className="mb-2 flex flex-col justify-between md:mb-0 md:flex-row md:justify-start">
              <div className="text-gray-600">Reference:</div>
              <div className="font-bold md:ml-3">
                [
                {`${
                  props.getValues('investingProfile.option') === InvestingPersonEnum.IN_BEHALF_OF_AN_ENTITY
                    ? props.getValues('entityDetails.companyName')
                    : props.getValues('basicInfo.firstName') + ' ' + props.getValues('basicInfo.lastName')
                }`}
                ] - [{props.getValues('investingProfile.tradeId')}] - AFBC2
              </div>
            </div>

            <div className="mb-2 flex flex-col justify-between md:mb-0 md:flex-row md:justify-start">
              <div className="text-gray-600">Address:</div>
              <div className="font-bold md:ml-3">
                One Oxford Centre, Suite 2700301 Grant Street, Pittsburgh , PA, United States 15219
              </div>
            </div>
          </div>
          <div className="flex flex-col lg:flex-row lg:justify-between"></div>
          <div className="mt-4 text-base leading-5 text-gray-500">
            By clicking "Continue", you agree that you will initiate a wire payment.
          </div>
          <div className="w-full gap-3 py-10 sm:block md:flex">
            <div className="flex flex-col sm:w-[100%] md:w-[20%]">
              <Button btnName={'Back'} onClickHandler={() => props.previousStep('8')} />
            </div>
            <div className="flex flex-col sm:w-[100%] md:w-[80%]">
              <Button btnName={'Continue'} btnType={'button'} onClickHandler={handleConfirmWirePayment} />
              <button />
            </div>
          </div>
        </div>
      </div>
      <LoaderModal isVisible={isLoading} />
      <ErrorMessageModal
        isVisible={error !== ''}
        onProceed={() => {
          setError('')
        }}
        onCancel={() => {}}
        error={error}
        btn2={'Ok'}
      />
    </div>
  )
}

export default BankWire
